import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/footer/instagram.svg'
import _imports_1 from '../../../assets/static/footer/linkedin.svg'
import _imports_2 from '../../../assets/static/global-outlined-white.svg'
import _imports_3 from '../../../assets/static/footer/facebook.svg'
import _imports_4 from '../../../assets/static/footer/tiktok.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f86427c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = { class: "footer-content__social" }
const _hoisted_5 = { class: "footer-content__social-links" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Instagram"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Linkedin"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  target: "_blank",
  href: "https://circulo.com.br/",
  class: "icon-linkedin",
  title: "Site Círculo"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "site"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  target: "_blank",
  href: "https://www.facebook.com/circuloprodutos",
  class: "icon-linkedin",
  title: "Facebook"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Facebook"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  target: "_blank",
  href: "https://www.tiktok.com/@circuloprodutos",
  class: "icon-linkedin",
  title: "Tiktok"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Tiktok"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "footer-content__contact" }
const _hoisted_22 = { class: "footer-content__contact-address" }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-content__credits" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.lincetec.com.br/",
    target: "_blank",
    title: "Lince Tech",
    class: "footer-content__credits-image"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.logo,
        alt: "Logo do Decola",
        class: "footer-logo"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              target: "_blank",
              href: _ctx.instagram,
              class: "icon-instagram",
              title: "Instagram"
            }, _hoisted_8, 8, _hoisted_6),
            (!_ctx.isCirculoTemplate)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "_blank",
                  href: _ctx.linkedin,
                  class: "icon-linkedin",
                  title: "Linkedin"
                }, _hoisted_11, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.isCirculoTemplate)
              ? (_openBlock(), _createElementBlock("a", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            (_ctx.isCirculoTemplate)
              ? (_openBlock(), _createElementBlock("a", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true),
            (_ctx.isCirculoTemplate)
              ? (_openBlock(), _createElementBlock("a", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("address", _hoisted_22, [
            _createElementVNode("a", {
              href: `malito:` + _ctx.email,
              title: "E-mail"
            }, _toDisplayString(_ctx.email), 9, _hoisted_23),
            _createElementVNode("span", null, _toDisplayString(_ctx.phone), 1)
          ])
        ])
      ]),
      _hoisted_24
    ]),
    _createElementVNode("span", null, " Copyright © " + _toDisplayString(_ctx.getCurrentYear()) + " Lince Tech. Todos os direitos reservados. ", 1)
  ]))
}